module.exports = __webpack_public_path__ + "static/img/6-6.3578e3f8.jpeg";